"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavbarDropdown = exports.NavbarText = exports.NavbarLink = exports.NavbarControls = exports.NavbarContainer = exports.NavbarIcon = exports.NavbarDivisor = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ifOnly = _interopRequireDefault(require("if-only"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var navbarClassName = function navbarClassName(props) {
  return (0, _classnames.default)('Navbar', {
    'Navbar--with-container': props.withContainer,
    'Navbar--inverse': props.inversed
  }, props.className);
};

var NavbarDivisor = function NavbarDivisor() {
  return _react.default.createElement("div", {
    className: "Navbar__divisor"
  });
};

exports.NavbarDivisor = NavbarDivisor;

var NavbarIcon = function NavbarIcon(_ref) {
  var image = _ref.image;
  return _react.default.createElement("div", {
    className: "Navbar__icon"
  }, _react.default.createElement("img", {
    src: image
  }));
};

exports.NavbarIcon = NavbarIcon;

var NavbarContainer = function NavbarContainer(_ref2) {
  var children = _ref2.children,
      style = _ref2.style;
  return _react.default.createElement("div", {
    className: "Navbar__container",
    style: style
  }, children);
};

exports.NavbarContainer = NavbarContainer;

var NavbarControls = function NavbarControls(_ref3) {
  var children = _ref3.children,
      className = _ref3.className;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)("Navbar__controls", className)
  }, children);
};

exports.NavbarControls = NavbarControls;

var NavbarLink = function NavbarLink(_ref4) {
  var children = _ref4.children,
      component = _ref4.component;

  if (component) {
    return _react.default.createElement(component, {
      className: "Navbar__link"
    }, children);
  }

  return _react.default.createElement("div", {
    className: "Navbar__link"
  }, children);
};

exports.NavbarLink = NavbarLink;

var NavbarText = function NavbarText(_ref5) {
  var children = _ref5.children;
  return _react.default.createElement("div", {
    className: "Navbar__text"
  }, children);
};

exports.NavbarText = NavbarText;

var NavbarDropdown = function NavbarDropdown(_ref6) {
  var children = _ref6.children;
  return _react.default.createElement("div", {
    className: "Navbar__dropdown"
  }, children);
};

exports.NavbarDropdown = NavbarDropdown;

var MobileNavbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MobileNavbar, _React$Component);

  function MobileNavbar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, MobileNavbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MobileNavbar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "styles", {
      navbarMenu: {
        flex: 1,
        fontSize: '2em',
        textAlign: 'right',
        cursor: 'pointer'
      },
      container: {
        width: '100vw'
      },
      controls: {
        width: '100vw',
        paddingTop: '5px',
        whiteSpace: 'nowrap',
        overflow: 'auto',
        flexShrink: 0
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isOpen: false
    });

    return _this;
  }

  _createClass(MobileNavbar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children; // const { isOpen } = this.state;

      var ChildNavbarControls = _react.default.Children.toArray(children).find(function (c) {
        return c.type === NavbarControls;
      });

      return _react.default.createElement("div", {
        className: navbarClassName(this.props),
        style: {
          height: 'auto',
          flexDirection: 'column',
          paddingBottom: 0
        }
      }, _react.default.createElement(NavbarContainer, {
        style: this.styles.container
      }, _react.default.Children.map(children, function (c) {
        if (c.type === NavbarControls) {
          return _react.default.createElement("div", {
            style: _this2.styles.navbarMenu
          }, _react.default.createElement("i", {
            className: "dbi dbi-arrow-left"
          }));
        }

        return c;
      })), _react.default.createElement("div", {
        style: this.styles.controls
      }, _react.default.cloneElement(ChildNavbarControls)));
    }
  }]);

  return MobileNavbar;
}(_react.default.Component);

var Navbar =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Navbar, _React$Component2);

  function Navbar(props) {
    var _this3;

    _classCallCheck(this, Navbar);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Navbar).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "MEDIA_QUERY_PHONE_WIDTH", 425);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this3)), "state", {
      useMobileNavbar: false
    });

    _this3._handleResize = _this3._handleResize.bind(_assertThisInitialized(_assertThisInitialized(_this3)));
    return _this3;
  }

  _createClass(Navbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this._handleResize);

      this._handleResize();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          withContainer = _this$props.withContainer,
          children = _this$props.children;
      var useMobileNavbar = this.state.useMobileNavbar;

      if (!useMobileNavbar) {
        return _react.default.createElement("div", {
          className: navbarClassName(this.props)
        }, withContainer ? _react.default.createElement(NavbarContainer, null, children) : children);
      } else {
        return _react.default.createElement(MobileNavbar, this.props);
      }
    }
  }, {
    key: "_handleResize",
    value: function _handleResize() {// const width = window.innerWidth;
      // if (width <= this.MEDIA_QUERY_PHONE_WIDTH) {
      //   this.setState({ useMobileNavbar: true });
      // }
      // else {
      //   this.setState({ useMobileNavbar: false });
      // }
    }
  }]);

  return Navbar;
}(_react.default.Component);

var _default = Navbar;
exports.default = _default;